import api from './api';

export type Notificacao = {
  id: string;
  tipo: string;
  titulo: string;
  mensagem?: string | null;
  link?: string | null;
  emendaId?: string | null;
  planoId?: string | null;
  lida: boolean;
  criadaEm: string;
};

export type NotificacaoPagina = {
  itens: Notificacao[];
  pagina: number;
  tamanho: number;
  total: number;
  naoLidas: number;
};

export const notificacaoService = {
  listar: async (pagina = 0, tamanho = 20): Promise<NotificacaoPagina> => {
    const { data } = await api.get<NotificacaoPagina>('/notificacoes', { params: { pagina, tamanho } });
    return data;
  },
  contarNaoLidas: async (): Promise<number> => {
    const { data } = await api.get<{ naoLidas: number }>('/notificacoes/nao-lidas/contagem');
    return data.naoLidas;
  },
  marcarLida: async (id: string): Promise<void> => {
    await api.post(`/notificacoes/${id}/lida`);
  },
  marcarTodasLidas: async (): Promise<void> => {
    await api.post('/notificacoes/lidas');
  },
};
